import React from 'react';
import moment from 'moment-timezone';

export default function TrainingPeriod({ training }) {
    const period = training?.instituicoes?.[0];
    const dates = [['Início', period?.data_inicial], ['Encerramento', period?.data_final]];
    return <div className="training-dates">
        {dates.filter(([, value]) => value && moment(value).isValid()).map(([label, value]) =>
            <span key={label}><i className="mdi mdi-calendar-clock" aria-hidden="true" /><span><small>{label}</small><strong>{moment(value).format('DD/MM/YYYY HH:mm')}</strong></span></span>
        )}
    </div>;
}
